import React, { useEffect, useState } from "react"
import { useContext } from "react"
import Layout from "../components/layout"
// import ScrollAnimation from "react-animate-on-scroll"
import { Link, graphql } from "gatsby"
import Seo from "../components/seo"
import { StaticImage } from "gatsby-plugin-image"
import { LazyLoadComponent } from "react-lazy-load-image-component"
import WebriQForm from "@webriq/gatsby-webriq-form"

import { FcBullish, FcOrgUnit, FcSettings } from "react-icons/fc"
import {
  Accordion,
  AccordionContext,
  Card,
  useAccordionToggle,
} from "react-bootstrap"

import "./our-approach.css"

import loadable from "@loadable/component"
import pMinDelay from "p-min-delay"

const QuandaryValues = loadable(() =>
  pMinDelay(import("../components/new-quandary/quandary-value-approach"), 500)
)

// const QuandaryValues = loadable(() =>
//   pMinDelay(import("../components/new-quandary/approach-peaks.js"), 500)
// )
const Testimonials2 = loadable(() =>
  pMinDelay(import("../components/swiper/testimonial-swiper"), 500)
)
const PartnerSwiper = loadable(() =>
  pMinDelay(import("../components/swiper/swiper-partner.js"), 500)
)
const Cases = loadable(() => pMinDelay(import("../components/cases"), 500))

const TestimonialSwiper = loadable(() =>
  pMinDelay(import("../components/swiper/testimonial-swiper-contact.js"), 500)
)

const Hero = loadable(() =>
  pMinDelay(import("../components/hero/hero-approach.js"), 500)
)
const InnovationAnalysis = loadable(() =>
  pMinDelay(import("../components/approach-innovation.js"), 500)
)
const ApproachFaqs = loadable(() =>
  pMinDelay(import("../components/approach-faqs.js"), 500)
)
const CaseStudySection = loadable(() =>
  pMinDelay(import("../components/header/header-casestudy-section.js"), 500)
)

const Partners = loadable(() =>
  pMinDelay(import("../components/unlock-enterprise.js"), 500)
)

const HomeTeam = loadable(() =>
  pMinDelay(import("../components/hero/banner-hometeam.js"), 500)
)

class OurApproachPage extends React.Component {
  render() {
    const { data } = this.props
    return (
      <Layout location={this.props.location} banner={<Hero />}>
        <Seo
          title="Our Approach | Quandary Consulting Group"
          description="Tired of managing your vendor? Our process delivers business value in days—without dragging you into the process."
        />
        <div className="page-content pb-0 pt-0">
          <PartnerSwiper />
          <InnovationAnalysis />

          {/* <LazyLoadComponent>
            <section
              id="peaks-methodology"
              className="peaks"
              style={{
                padding: "3rem 0",
                background: "#ecf0f2",
                scrollMarginTop: "3.5rem",
              }}
            >
              <div className="container">
                <div className="row">
                  <div className="col-lg-8 mx-auto text-center">
                    <h2>Guided By PEAKS</h2>
                    <p>
                      PEAKS serves as our foundation for every project we
                      complete. This ensures you receive the highest level of
                      care, commitment, and expertise.
                    </p>
                    <p>
                      You get consistency, clarity, and follow-through because
                      our PEAKS framework guides every project. These principles
                      keep us locked in and your project moving—even when
                      priorities shift.
                    </p>
                  </div>
                  <div className="col-lg-12 mt-3">
                    <QuandaryValues />
                  </div>
                </div>
              </div>
            </section>
          </LazyLoadComponent> */}
          <LazyLoadComponent>
            <section
              className="faq-wrapper security-audit"
              style={{ padding: "3rem 0" }}
            >
              <div className="container">
                <div className="row">
                  <div className="col-lg-9 mx-auto">
                    <h2 className="mt-0 text-center mt-6">
                      PEAKS Delivery System
                    </h2>
                    <p className="text-center">
                      Get value in weeks (or days) with our design-led approach
                      that aligns teams and builds momentum from the start.
                    </p>
                    <Accordion defaultActiveKey="0" key="1">
                      <Card className="accordion-body">
                        <ContextAwareToggle
                          eventKey="1"
                          className="bg-transparent"
                        >
                          1. Setup & Handoff
                        </ContextAwareToggle>
                        <Accordion.Collapse eventKey="1">
                          <Card.Body>
                            <p>
                              After kickoff, we align internally—assigning the
                              right team, tools, and structure.
                            </p>
                          </Card.Body>
                        </Accordion.Collapse>
                      </Card>
                    </Accordion>
                    <Accordion defaultActiveKey="0" key="2">
                      <Card className="accordion-body">
                        <ContextAwareToggle
                          eventKey="2"
                          className="bg-transparent"
                        >
                          2. Client Kickoff
                        </ContextAwareToggle>
                        <Accordion.Collapse eventKey="2">
                          <Card.Body>
                            <p>
                              We clarify goals, map priorities, and align on
                              what progress should look like.
                            </p>
                          </Card.Body>
                        </Accordion.Collapse>
                      </Card>
                    </Accordion>
                    <Accordion defaultActiveKey="0" key="3">
                      <Card className="accordion-body">
                        <ContextAwareToggle
                          eventKey="3"
                          className="bg-transparent"
                        >
                          3. Design First
                        </ContextAwareToggle>
                        <Accordion.Collapse eventKey="3">
                          <Card.Body>
                            <p>
                              No product owner? No problem. We lead with design
                              to give the work direction, pace, and early
                              momentum.
                            </p>
                          </Card.Body>
                        </Accordion.Collapse>
                      </Card>
                    </Accordion>
                    <Accordion defaultActiveKey="0" key="4">
                      <Card className="accordion-body">
                        <ContextAwareToggle
                          eventKey="4"
                          className="bg-transparent"
                        >
                          4. Weekly Planning Cycles
                        </ContextAwareToggle>
                        <Accordion.Collapse eventKey="4">
                          <Card.Body>
                            <p>
                              Monday priorities, Friday outcomes. Adjust without
                              losing momentum.
                            </p>
                          </Card.Body>
                        </Accordion.Collapse>
                      </Card>
                    </Accordion>
                    <Accordion defaultActiveKey="0" key="5">
                      <Card className="accordion-body">
                        <ContextAwareToggle
                          eventKey="5"
                          className="bg-transparent"
                        >
                          5. Working Sessions
                        </ContextAwareToggle>
                        <Accordion.Collapse eventKey="5">
                          <Card.Body>
                            <p>
                              Design discussions, demos, and problem-solving
                              sessions happen throughout. Always lightweight.
                            </p>
                          </Card.Body>
                        </Accordion.Collapse>
                      </Card>
                    </Accordion>
                    <Accordion defaultActiveKey="0" key="6">
                      <Card className="accordion-body">
                        <ContextAwareToggle
                          eventKey="6"
                          className="bg-transparent"
                        >
                          6. Internal Oversight & Escalation
                        </ContextAwareToggle>
                        <Accordion.Collapse eventKey="6">
                          <Card.Body>
                            <p>
                              Weekly internal check-ins surface and solve
                              blockers early before they disrupt your team.
                            </p>
                          </Card.Body>
                        </Accordion.Collapse>
                      </Card>
                    </Accordion>
                    <Accordion defaultActiveKey="0" key="7">
                      <Card className="accordion-body">
                        <ContextAwareToggle
                          eventKey="7"
                          className="bg-transparent"
                        >
                          7. Ongoing Improvement
                        </ContextAwareToggle>
                        <Accordion.Collapse eventKey="7">
                          <Card.Body>
                            <p>
                              We backlog new priorities by time to value—so the
                              next win is always within reach.
                            </p>
                          </Card.Body>
                        </Accordion.Collapse>
                      </Card>
                    </Accordion>
                  </div>
                </div>
              </div>
            </section>
          </LazyLoadComponent>
          <ApproachFaqs />
          {/* <LazyLoadComponent>
            <section
              style={{
                padding: "1rem 0 3rem 0",
                background: "#fff",
              }}
            >
              <div className="container">
                <div className="row">
                  <div className="col-lg-8 mx-auto text-center text-left-mobile">
                    <StaticImage
                      placeholder="blurred"
                      imgClassName="img-fluid"
                      src="../images/new-images/approach/sprints.jpg"
                      alt="peakSUITE TRAILHEAD"
                      layout="constrained"
                      loading="lazy"
                    />

                    <h2 className="about-titlehead">
                      Streamline Operations In Your Organization
                    </h2>

                    <p>
                      Data errors, slowdowns, and customer frustration aren’t
                      “growing pains”, they’re signs of a deeper problem. It’s
                      time to find and fix that problem.
                    </p>
                  </div>

                  <div className="col-lg-8 mx-auto text-center mt-5">
                    <Link
                      aria-label="link"
                      className="btn btn-primary btn-arrow"
                      to="/contact/"
                    >
                      Improve Your Systems
                    </Link>
                  </div>
                </div>
              </div>
            </section>
          </LazyLoadComponent> */}

          {/* <LazyLoadComponent>
            <section
              className="quick-base-glance"
              style={{
                padding: "3rem 0",
                boxShadow: "rgba(0, 0, 0, 0.16) 0px 3px 100px",
              }}
            >
              <div className="container">
                <div className="row">
                  <div className="col-lg-12">
                    <h2 className="text-center mb-5">
                      Is Quandary Right for Your Business?
                    </h2>
                  </div>
                  <div className="col-lg-4 col-md-6 mt-5 text-center">
                    <div className="text-center mx-auto">
                      <FcOrgUnit />
                    </div>
                    <h5 className="mt-4 mb-2 font-weight-bold">
                      Your Data Is
                      <br />
                      Fragmented
                    </h5>
                    <p>
                      Create custom, automated workflows without learning code.
                    </p>
                  </div>
                  <div className="col-lg-4 col-md-6 mt-5 text-center">
                    <div className="text-center mx-auto">
                      <FcBullish />
                    </div>

                    <h5 className="mt-4 mb-2 font-weight-bold">
                      Your Profit Hasn’t Kept Pace with Growth
                    </h5>
                    <p>
                      Your operational costs continue to rise despite acquiring
                      new customers, training your team, and implementing
                      numerous cost-cutting techniques.
                    </p>
                  </div>
                  <div className="col-lg-4 col-md-6 mt-5 text-center">
                    <div className="text-center mx-auto">
                      <FcSettings />
                    </div>
                    <h5 className="mt-4 mb-2 font-weight-bold">
                      You Need Custom
                      <br />
                      Applications
                    </h5>
                    <p>
                      You understand the value of investing in digital solutions
                      to scale your business. And you want them built to spec
                      within budget quickly.
                    </p>
                  </div>
                </div>
              </div>
            </section>
          </LazyLoadComponent> */}
          <Testimonials2 />
          <CaseStudySection />
          <section id="case-studies-container">
            <div id="case-studies" className="bg-indigo">
              <div className="container">
                <div className="intro text-center">
                  <div className="row">
                    <div className="col-md-10 mx-auto">
                      <p className="h5 text-light-blue text-uppercase font-weight-bold m-0">
                        Case Studies
                      </p>
                      <h2 className=" my-2 text-white">
                        We Save Clients 1000s of Hours. Every Year.
                      </h2>
                      {/* <p className="text-white">
                        We helped a national healthcare provider save over 9,000
                        hours in weekly labor costs by developing a single
                        application...
                      </p> */}
                    </div>
                  </div>
                </div>
              </div>
              {/* <Suspense fallback={<div>Loading...</div>}> */}
              <Cases allSanityCaseStudy={this.props.data.allSanityCaseStudy} />
              {/* </Suspense> */}
            </div>
          </section>
          <HomeTeam />
          <Partners />
          <section
            className="bg-case-study slogan-section"
            style={{
              paddingTop: "5rem",
              paddingBottom: "5rem",
            }}
          >
            <div className="container">
              <div className="row">
                <div className="col-lg-10 mx-auto text-center">
                  <div>
                    <h2 className="text-white">
                      We Run the Process So You Can Run the Business
                    </h2>
                    {/* <p className="text-white">
                  Our 10-point security audit will show you how secure your
                  applications are. <br /> Protect your data. Protect your
                  investment. Protect your organization.
                </p> */}

                    <Link
                      to="/contact/"
                      className="btn btn-primary btn-arrow mr-2 mt-4 text-center py-3 text-uppercase"
                      style={{ marginTop: "auto" }}
                    >
                      Let's Chat
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
      </Layout>
    )
  }
}

export default OurApproachPage

function ContextAwareToggle({ children, eventKey, callback }) {
  const currentEventKey = useContext(AccordionContext)

  const decoratedOnClick = useAccordionToggle(
    eventKey,
    () => callback && callback(eventKey)
  )

  const isCurrentEventKey = currentEventKey === eventKey

  return (
    <Card.Header
      className={isCurrentEventKey ? "accordion-active" : "accordion-collapsed"}
    >
      <button
        aria-label="btn"
        type="button"
        onClick={decoratedOnClick}
        className={`m-0 border-0 bg-transparent w-100 text-left ${
          isCurrentEventKey ? "text-primary-gradient" : ""
        }`}
      >
        <p className="h5 text-left toggle-btn">{children}</p>
        <div>
          <div className="btn-plus-minus" />
        </div>
      </button>
    </Card.Header>
  )
}

export const ApproachQuery = graphql`
  query ApproachQuery {
    site {
      siteMetadata {
        title
        author
        description
      }
    }
    allSanityCaseStudy(sort: { fields: [publishedAt], order: DESC }, limit: 3) {
      edges {
        node {
          title
          publishedAt(formatString: "MMMM DD, YYYY")
          mainImage {
            asset {
              gatsbyImageData(
                fit: FILL
                placeholder: BLURRED
                sizes: ""
                layout: CONSTRAINED
              )
            }
          }
          bannerImage {
            asset {
              gatsbyImageData(
                fit: FILL
                placeholder: BLURRED
                sizes: ""
                layout: CONSTRAINED
              )
            }
          }
          slug {
            current
          }
        }
      }
    }
  }
`
